import React from "react";

export const LoadingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={160}
    height={161}
    viewBox="0 0 160 161"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M80 20.5V40.5"
      stroke="url(#paint0_linear)"
      strokeWidth={12}
      strokeLinecap="round"
    />
    <path
      d="M80 120.5V140.5"
      stroke="url(#paint1_linear)"
      strokeWidth={12}
      strokeLinecap="round"
    />
    <path
      d="M140 80.5L120 80.5"
      stroke="url(#paint2_linear)"
      strokeWidth={12}
      strokeLinecap="round"
    />
    <path
      d="M40 80.5L20 80.5"
      stroke="url(#paint3_linear)"
      strokeWidth={12}
      strokeLinecap="round"
    />
    <path
      d="M122.423 38.0781L108.281 52.2203"
      stroke="url(#paint4_linear)"
      strokeWidth={12}
      strokeLinecap="round"
    />
    <path
      d="M51.7134 108.781L37.5713 122.923"
      stroke="url(#paint5_linear)"
      strokeWidth={12}
      strokeLinecap="round"
    />
    <path
      d="M122.423 122.923L108.281 108.781"
      stroke="url(#paint6_linear)"
      strokeWidth={12}
      strokeLinecap="round"
    />
    <path
      d="M51.7134 52.2203L37.5713 38.0781"
      stroke="url(#paint7_linear)"
      strokeWidth={12}
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1={80.5}
        y1={20.5}
        x2={80.5}
        y2={40.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#231F20" />
        <stop offset="1" stopColor="#F01709" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1={80.5}
        y1={120.5}
        x2={80.5}
        y2={140.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#231F20" />
        <stop offset="1" stopColor="#F01709" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1={130}
        y1={80.5}
        x2={130}
        y2={81.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#231F20" />
        <stop offset="1" stopColor="#F01709" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1={30}
        y1={80.5}
        x2={30}
        y2={81.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#231F20" />
        <stop offset="1" stopColor="#F01709" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1={115.352}
        y1={38.0781}
        x2={115.352}
        y2={52.2203}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#231F20" />
        <stop offset="1" stopColor="#F01709" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1={44.6424}
        y1={108.781}
        x2={44.6424}
        y2={122.923}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#231F20" />
        <stop offset="1" stopColor="#F01709" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1={115.352}
        y1={108.781}
        x2={115.352}
        y2={122.923}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#231F20" />
        <stop offset="1" stopColor="#F01709" />
      </linearGradient>
      <linearGradient
        id="paint7_linear"
        x1={44.6424}
        y1={38.0781}
        x2={44.6424}
        y2={52.2203}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#231F20" />
        <stop offset="1" stopColor="#F01709" />
      </linearGradient>
    </defs>
  </svg>
);
